<template>
  <v-dialog
    v-model="visibilidade_carrinho_compra"
    fullscreen
    transition="dialog-bottom-transition"
    persistent
  >
    <template #activator="{ on, attrs }">
      <button id="btn-carrinho" :class="{'cursor-no-drop': !pedido.id}" @click="abrirCarrinhoCompra">
        <v-icon v-text="'mdi-cart'" color="#142454" />
        <span v-text="'Carrinho'" />

        <span class="quantidade font-11">
          <v-progress-circular
            v-if="carregando_dados"
            color="red"
            indeterminate
            size="16"
            width="1.5"
          />
          <span v-else v-text="pedido.qtd_categorias || 0" />
        </span>
      </button>
    </template>

    <v-card>
      <Titulo
        v-model="visibilidade_carrinho_compra"
        :pedido="pedido"
        @pedido-compra-finalizado="pedidoCompraFinalizado"
      />

      <TabelaProdutos v-if="visibilidade_carrinho_compra" :pedido="pedido" />
    </v-card>
  </v-dialog>
</template>

<script>
import VisibilidadeCarrinhoCompraComputed from "./VisibilidadeCarrinhoCompraComputed.js";
import Titulo from "./Titulo.vue";
import TabelaProdutos from "./TabelaProdutos.vue";

import {parametros_rota} from "../helpers/ParametrosRota.js";
import {buscarPedidoAbertoDepartamento} from "../../../../api/compraPorDepartamentos/PedidoCompraTipo";
import {mapGetters} from "vuex";

const PEDIDO_DEFAULT = {
  id: null,
  qtd_produtos: 0,
  created_at: null
}

export default {
  name: "Index",
  components: {
    Titulo,
    TabelaProdutos
  },
  mixins: [VisibilidadeCarrinhoCompraComputed, parametros_rota],
  data: () => ({
    carregando_dados: false,
    pedido:  {}
  }),
  computed: {
    ...mapGetters({
      'callbackAtualizarTabelaCategorias': 'comprasPorDepartamentos/callbackAtualizarTabelaCategorias'
    }),
  },
  watch: {
    grupo_compra() {
      this.buscarPedidoAbertosDepartamento();
    },
    filial_compra() {
      this.buscarPedidoAbertosDepartamento();
    },
    departamento_compra() {
      this.buscarPedidoAbertosDepartamento();
    },
    visibilidade_carrinho_compra(valor) {
      if (!valor) {
        this.callbackAtualizarTabelaCategorias();
        this.buscarPedidoAbertosDepartamento();
      }
    }
  },
  created() {
    this.buscarPedidoAbertosDepartamento();
    this.setCallbackAtualizarCarrinho();
  },
  destroyed() {
    this.visibilidade_carrinho_compra = false;
  },
  methods: {
    async buscarPedidoAbertosDepartamento() {
      this.carregando_dados = true;
      const pedido = await buscarPedidoAbertoDepartamento(this.PARAMETROS);

      if (pedido && pedido.id > 0) {
        this.pedido = pedido;
      } else {
        this.setPedidoDefault();
      }

      this.carregando_dados = false;
    },
    setPedidoDefault() {
      this.pedido = Object.assign({}, PEDIDO_DEFAULT);
    },
    setCallbackAtualizarCarrinho() {
      // função serve para atualizar o carrinho de qualquer lugar.
      this.$store.dispatch("carrinhoDepartamentos/atualizarPedidoCarrinhoCallback", this.buscarPedidoAbertosDepartamento)
    },
    abrirCarrinhoCompra() {
      if (!this.pedido.id) return;

      this.visibilidade_carrinho_compra = true;
    },
    pedidoCompraFinalizado() {
      this.visibilidade_carrinho_compra = false;
    }
  }
}
</script>

<style scoped>
#btn-carrinho {
  padding: 2px 8px;
  background: #F7F8FD;
  border-radius: 8px;
  color: #142454;
}
#btn-carrinho .quantidade {
  position: absolute;
  top: 3px;
  right: 10px;
  background: white;
  border-radius: 50%;
  border: 1px solid #948989;
  height: 20px;
  min-width: 20px;
}
</style>
